"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerToPort = exports.stringToNumber = exports.normalize = void 0;
const crypto = __importStar(require("crypto"));
const big_integer_1 = __importDefault(require("big-integer"));
const normalize = (value, newMin, newMax, oldMin, oldMax) => {
    value = (0, big_integer_1.default)(value);
    newMin = (0, big_integer_1.default)(newMin);
    newMax = (0, big_integer_1.default)(newMax);
    oldMin = (0, big_integer_1.default)(oldMin);
    oldMax = (0, big_integer_1.default)(oldMax);
    const newRange = newMax.subtract(newMin);
    const oldDiff = value.subtract(oldMin);
    const oldRange = oldMax.subtract(oldMin);
    return newRange.multiply(oldDiff).divide(oldRange).add(newMin);
};
exports.normalize = normalize;
const bit256 = (0, big_integer_1.default)(2).pow(256).minus(1);
const stringToNumber = (customer) => {
    const hash = crypto.createHash('sha256').update(customer).digest('hex');
    const value = (0, big_integer_1.default)(hash, 16);
    return (0, exports.normalize)(value, big_integer_1.default.zero, Number.MAX_SAFE_INTEGER, big_integer_1.default.zero, bit256).toJSNumber();
};
exports.stringToNumber = stringToNumber;
const customerToPort = (customer) => {
    const number = (0, exports.stringToNumber)(customer);
    return (0, exports.normalize)(number, 9900, 9998, 0, Number.MAX_SAFE_INTEGER).toJSNumber();
};
exports.customerToPort = customerToPort;
//# sourceMappingURL=stringToNumber.js.map